import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { InvalidFieldMessageService } from 'src/app/services/invalid-field-message/invalid-field-message.service';
import { RegisterService } from 'src/app/services/register/register.service';
import { ResetPasswordService } from 'src/app/services/reset-password/reset-password.service';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
  providers: []
})
export class ForgotPasswordPage implements AfterViewInit {
  @ViewChild('emailInput') emailInput?: ElementRef;
  forgotPasswordFormGroup: FormGroup;
  public loading: boolean = false;
  constructor(private formBuilder: FormBuilder, private messageService: InvalidFieldMessageService, private registerService: RegisterService, private authenticationService: AuthenticationService,
  private snackBar: MatSnackBar, private translateService: TranslateService, private resetPasswordService: ResetPasswordService,
  public appConfig: AppConfigService) {
    this.authenticationService.verifyIfIsLogged();
    this.forgotPasswordFormGroup  = this.formBuilder.group({
      email: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(5), Validators.email]]
    });
  }

  ngAfterViewInit(): void {
    this.emailInput?.nativeElement.focus();
  }

  get message() {
    return this.messageService
  }

  get form()
  {
    return this.forgotPasswordFormGroup.controls;
  }

  public async resetPassword() {
    this.loading = true;
    try {
      if(this.forgotPasswordFormGroup.valid) {
        if(await this.isEmailValid()) {
          await this.resetPasswordService.sendResetPasswordEmail(this.form['email'].value);
          const censoredEmail: string = this.censorEmail(this.form['email'].value)
          this.snackBar.open(this.translateService.instant("forgotPassword.emailSuccess", {email: censoredEmail}), '', {
            duration: 10000,
            verticalPosition: 'top',
          panelClass: ['green-snackbar']
          });
        } else {
          this.snackBar.open(this.translateService.instant("forgotPassword.emailDontExist"), '', {
            duration: 10000,
            verticalPosition: 'top',
          panelClass: ['red-snackbar']
          });
        }
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.snackBar.open(this.translateService.instant('api.internalServerError'), '', {
        duration: 10000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    }
  }

  public async isEmailValid(): Promise<boolean> {
    if(this.form['email'].value && !this.form['email'].errors) {
      const r = await this.registerService.emailExists(this.form['email'].value)
      if(r) {
        return true
      }
    }
    return false
  }

  private censorEmail(email: string): string {
    let censoredEmail = email.split('@');
    let firstPart = censoredEmail[0];
    let secondPart = censoredEmail[1]
    firstPart = (firstPart[0] + "*".repeat(firstPart.length - 2) + firstPart.slice(-1));
    return firstPart + "@" + secondPart;
  }
}